/**
 * SMS and Firebase Auth error handling utilities
 */

/**
 * Get a user-friendly error message from Firebase Auth error code
 * @param errorCode - Firebase Auth error code
 * @param defaultMessage - Default message if error code is not recognized
 * @returns User-friendly error message
 */
export const getAuthErrorMessage = (errorCode?: string, defaultMessage?: string): string => {
  const defaultMsg = defaultMessage || 'An error occurred. Please try again.';
  
  if (!errorCode) return defaultMsg;

  switch (errorCode) {
    case 'auth/invalid-phone-number':
      return 'Invalid phone number format.';
    case 'auth/too-many-requests':
      return 'Too many requests. Please try again later.';
    case 'auth/captcha-check-failed':
      return 'reCAPTCHA verification failed. Please try again.';
    case 'auth/missing-app-credential':
      return 'Firebase configuration error.';
    case 'auth/quota-exceeded':
      return 'SMS quota exceeded. Please try again later.';
    case 'auth/invalid-verification-code':
      return 'Invalid verification code. Please try again.';
    case 'auth/code-expired':
      return 'Verification code expired. Please request a new one.';
    default:
      return defaultMsg;
  }
};

